'use client';
import { usePathname } from 'next/navigation';

import { useOnce } from './hooks/useOnce';
import { pushToDataLayer } from './pushToDataLayer';

interface PageEventProps {
  event: string;
  page: string;
}
export enum PageType {
  Home = 'Home Page',
  Listing = 'Listing Page',
  Product = 'Detail Page',
  Basket = 'Basket Page',
  Payment = 'Transaction',
}

export const pageTypeGTM = (type: string) => {
  const pageEvent = {
    event: 'virtualPageview',
    pageType: type,
  };
  pushToDataLayer(pageEvent);
};

export const pageView = (url: string) => {
  const pageEvent: PageEventProps = {
    event: 'virtualPageview',
    page: url,
  };
  pushToDataLayer(pageEvent);
};

export const GTMPageView = () => {
  const path = usePathname() || '/';

  useOnce(() => {
    // according to the docs, we should send every page view to GA
    pageView(path);
  });

  return null;
};
